import styled from 'styled-components';

export default styled.button`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  text-decoration: underline;
`;
